import { PROFILE_DETAILS_CONTENT_MAX_HEIGHT } from '@aibees/elephant/constants';
import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: (p) => `${p.spacing(PROFILE_DETAILS_CONTENT_MAX_HEIGHT)} !important`,
};
